import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { MotivosUacModel } from 'src/app/models/motivos.model';
import { MotivosTramitesUacList, MotivosTramitesUacListPK } from 'src/app/models/motivosTramitesUacList.model';
import { TramiteUACModel } from 'src/app/models/tramiteUAC.model';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { UtilService } from 'src/app/shared/services/util.service';

@Component({
    selector: 'app-configurar-motivo-consulta',
    templateUrl: './configurar-motivo-consulta.component.html',
    styleUrls: ['./configurar-motivo-consulta.component.css']
})
export class ConfigurarMotivoConsultaComponent implements OnInit {
    public modalOptionsGuardarVentanilla: any;
    public tramites: TramiteUACModel[];
    public idTramite;
    public motivos: MotivosUacModel[];
    public motivosXTramite: MotivosUacModel[];
    public motivosList: any[] = [];
    public motivosSelectList: any[] = [];
    constructor(private spinner: NgxSpinnerService,
        private urlService: UrlService,
        private alertService: AlertService,
        private utilService: UtilService,
        private global: GlobalService) { }

    async ngOnInit() {
        this.createModal()
        await this.consultarTramites();
        await this.consultarMotivos();
    }


    createModal() {
        this.modalOptionsGuardarVentanilla = new ConfirmationModalOptions(
            'Confirmación', ConstantesService.MSG_CONFIRMACION_GUARDAR_PARAMETRO,
            'SI', 'NO', 'fas fa-save', true, false,
            'Guardar',
            null, 'btn-secondary');
    }
    /**
     * Método que llama al servicio para realizar la consulta de tramites
     */
    async consultarTramites() {
        try {
            this.spinner.show();
            const serviceProvider = 'tramiteUAC';
            const pathParams: Array<[string, string]> = new Array<[string, string]>();
            pathParams.push([
                "filterBy=estado",
                ConstantesService.ESTADO_TRAMITE_ACTIVO,
            ]);
            const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, pathParams, null), this.urlService.hostAPI_UAC);
            let data = await this.global.getGenerico(url).toPromise();
            this.tramites = data;
        } catch (error) {
            this.catchException('No fue posible Cargar los Trámites');
        } finally {
            this.spinner.hide();
        }
    }

    async consultarMotivosXTramite() {
        try {
            this.spinner.show();
            const serviceProvider = 'motivosTramiteUAC';
            const pathParams: Array<[string, string]> = new Array<[string, string]>();
            pathParams.push([
                "filterBy=idTramite",
                this.idTramite,
            ]);
            const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, pathParams, null), this.urlService.hostAPI_UAC);
            let data = await this.global.getGenerico(url).toPromise();
            this.motivosXTramite = data;
            this.cargarMotivosXTramite();
        } catch (error) {
            this.catchException('No fue posible Cargar los Trámites');
        } finally {
            this.spinner.hide();
        }
    }

    cargarMotivosXTramite() {
        this.motivosList.forEach(motivo => {
            let existe = this.motivosXTramite.filter(x => motivo.id == x.motivoConsulta);
            if (existe.length > 0) {
                motivo.checked = existe[0].estado == ConstantesService.ESTADO_TRAMITE_ACTIVO ? true : false;
            } else {
                motivo.checked = false;
            }
        })
    }

    /**
     * Método que llama al servicio para realizar la consulta de motivos consulta
     */
    async consultarMotivos() {
        try {
			const queryParams: Array<[string, string]> = new Array<[string, string]>();
			queryParams.push([
			  "estado",
			  "ACT",
			]);
            this.spinner.show();
            const serviceProvider = 'consultarMotivos';
            const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
            let data = await this.global.getGenerico(url).toPromise();
            this.motivos = data;
            this.castearMotivosMultiples();
        } catch (error) {
            this.catchException('No fue posible Cargar los Motivos de consulta');
        } finally {
            this.spinner.hide();
        }
    }



    castearMotivosMultiples() {
        this.motivosList = [];
        for (let motivo of this.motivos) {
            let obj = { id: motivo.id, nombreElelemento: motivo.motivoConsulta, checked: false };
            this.motivosList.push(obj);
        }

    }


    getMotivosConsulta(evento: any) {
        this.motivosSelectList = evento.elementosSeleccionados;
        this.validarFormulario();
    }


    guardarParametro(event) {
        if (event[0]) {
            this.guardarMotivosTramites();
        }
    }

    async guardarMotivosTramites() {
        try {
            this.spinner.show();
            let motivosTramitesUacList: MotivosTramitesUacList = new MotivosTramitesUacList();
            motivosTramitesUacList.fechaCreacion = new Date();
            motivosTramitesUacList.fechaModificacion = new Date();
            motivosTramitesUacList.idTramite = this.idTramite;
            motivosTramitesUacList.usuarioModificacion = sessionStorage.getItem(ConstantesService.SIA3_SESSSION);
            motivosTramitesUacList.motivosConsulta = [];
            for (let motivo of this.motivosSelectList) {
                let nuevoMotivo: MotivosTramitesUacListPK = new MotivosTramitesUacListPK();
                nuevoMotivo.estado = motivo.checked ? 'ACT' : 'INA';
                nuevoMotivo.idMotivoConsulta = motivo.id;
                motivosTramitesUacList.motivosConsulta.push(nuevoMotivo)
            }
            const serviceProvider = 'motivosTramiteUAC';
            const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
            await this.global.postGenerico(url, motivosTramitesUacList).toPromise();
            await this.consultarMotivosXTramite();
            this.alertService.generateAlertSuccess('Se guardó información exitosamente', '');
        } catch (error) {
            this.catchException('Error al gestionar motivos de tramites');
        } finally {
            this.spinner.hide();
        }
    }


    /**
     *
     */
    catchException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spinner.hide();
    }

    async obtenerMotivosXTramite() {
        this.spinner.show();
        this.validarFormulario();
        await this.consultarMotivosXTramite();
        this.spinner.hide();
    }

    validarFormulario() {
        let validarCheckedMotivos = this.motivosSelectList.filter(x => x.checked === true);
        this.modalOptionsGuardarVentanilla.disabled = !(validarCheckedMotivos.length > 0 && this.idTramite != null && this.idTramite != undefined)
    }

}
